import { useState } from 'react';
import Accordion from "../../../../shared/Accordion";
import Module from './Module';

const List = (props) => {
  const [openItem, setOpenItem] = useState(null);

  const toggleAccordion = (moduleId) => {
    setOpenItem((prev) => (prev === moduleId ? null : moduleId));
  };

  return (
    <div className="block md:hidden space-y-4 p-4">
      {props.modules.length === 0 && (
        <div className="rounded-xl border border-gray-200 bg-white px-4 py-10 text-center text-sm text-gray-500">
          No hay módulos configurados.
        </div>
      )}
      {props.modules.map((module) => {
        const permissions = props.permissionsByModule(module.Id) || [];
        return (
          <Accordion
            key={module.Id}
            id={module.Id}
            title={module.Name}
            open={openItem === module.Id}
            onToggle={() => toggleAccordion(module.Id)}
            edit={props.isEditor}
            className="permissions-mobile-accordion rounded-lg border-gray-200 bg-white shadow-sm overflow-hidden"
          >
            <Module
                permissions={permissions}
                isEditor={props.isEditor}
                permissionsRoles={props.permissionsRoles}
                setPermissionsSave={props.setPermissionsSave}
            />
          </Accordion>
        );
      })}
    </div>
  );
};

export default List;
